import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  name: 'Vault',
  setup(__props, { expose }) {
  expose();

const appName = process.env.VUE_APP_TITLE as string;

const onLogin = () => {
    router.push('/login');
}


const __returned__ = { appName, onLogin }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})